import { useEffect } from 'react';

/*
* Хук для управления прокруткой в зависимости от состояния модальных окон
*/
export const useBodyOverflow = (modalStates: boolean[]) => {
	useEffect(() => {
		if (modalStates.some(state => state)) {
			document.body.style.overflowY = 'hidden';
		} else {
			document.body.style.overflowY = '';
		}
	}, [modalStates]);
};
